import type { ChangeEvent, Ref } from 'react';

import { OverwriteConfirmDialog } from './OverwriteConfirmDialog';

/**
 * The parts of uploading that have to exist in the document but are never
 * seen: the two file inputs the upload menu clicks, and the prompt for a file
 * that would overwrite one already in the folder.
 *
 * Takes the handlers one by one rather than the whole `useFileUploads` value:
 * passing a member expression to `ref` makes the compiler treat the object it
 * came from as a ref for the rest of the render, and every other read of it
 * then reports as a ref access during render.
 */
export function UploadPickers({
  setFilePicker,
  setFolderPicker,
  onPickerChange,
  collidingFileName,
  onConfirmOverwrite,
  onCancelOverwrite,
}: {
  setFilePicker: Ref<HTMLInputElement>;
  setFolderPicker: Ref<HTMLInputElement>;
  onPickerChange: (event: ChangeEvent<HTMLInputElement>) => void;
  collidingFileName: string | undefined;
  onConfirmOverwrite: () => void;
  onCancelOverwrite: () => void;
}) {
  return (
    <>
      <input
        ref={setFilePicker}
        type="file"
        multiple
        className="hidden"
        onChange={onPickerChange}
      />
      <input
        ref={setFolderPicker}
        type="file"
        multiple
        className="hidden"
        onChange={onPickerChange}
      />
      {collidingFileName !== undefined && (
        <OverwriteConfirmDialog
          fileName={collidingFileName}
          open
          onConfirm={onConfirmOverwrite}
          onCancel={onCancelOverwrite}
        />
      )}
    </>
  );
}
